import React from "react"
import style from "./skillbar.module.css"

export default ({ score }) => {
    let stars = [...Array(5).keys()].map(i => i < score ? <span className={style.checked}>★</span> : <span className={style.unchecked}>☆</span>)

    return <span className={style.rating}>{stars}</span>
}
